import moment from "moment";

const InitialValues = {
  reportType: "",
  startDate: moment().subtract(1, "months"),
  endDate: moment(),
};

export default InitialValues;
